import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Submit18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M14.2501 4V9.25H4.31077L7.03044 6.53033L5.96978 5.46967L1.43945 10L5.96978 14.5303L7.03044 13.4697L4.31078 10.75H15.7501V4H14.2501Z'
      fill='currentColor'
    />
  </Svg>
);

Submit18.displayName = 'Submit18';
export default Submit18;
